export default __webpack_public_path__ + "static/media/arrow-forward.1c988d87.svg";